import { Shell } from '../layouts/Shell'

export function NotAuthedPage() {
  return (
    <Shell>
      <div
        data-testid="not-authed"
        className="rounded-md border border-amber-900 bg-amber-950/40 p-6 text-sm text-amber-100"
      >
        <h1 className="text-lg font-semibold">Sign-in required</h1>
        <p className="mt-2 text-amber-200">
          The admin surface is gated at the Worker edge. You should have been
          redirected to the sign-in flow. If you're seeing this page directly,
          the gate cookie is missing or expired.
        </p>
      </div>
    </Shell>
  )
}
